import { defineComponent as _defineComponent } from 'vue'
import { getSection8OrganizationList } from '@/lib/formItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationForm',
  props: {
    isValid: { type: Boolean },
    isEditing: { type: Boolean },
    organizationId: null
  },
  emits: ["update:isValid", "update:organizationId"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:organizationId', data: string): void;
}), expose: any, slots: any, attrs: any }) {





const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updateOrganizationId = (e: string): void => {
  emits('update:organizationId', e);
};

return { __sfc: true,emits, updateIsValid, updateOrganizationId, getSection8OrganizationList }
}

})